var jquery = require("jquery");
window.$ = window.jQuery = jquery;
require('lazysizes');
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.preloadAfterLoad = true;
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// Initialize Lenis
const lenis = new Lenis({
	lerp: 0.05, 
	wheelMultiplier: 1.5,
});

// Integrate Lenis with ScrollTrigger
lenis.on('scroll', ScrollTrigger.update);

gsap.ticker.add((time) => {
	lenis.raf(time * 1000);
});

gsap.ticker.lagSmoothing(0);

let header = $('header');
let lastScrollTop = 0;
const delta = 5; // Reduced threshold for more responsive soft scrolling
const headerHeight = header.outerHeight();
let isHeaderHidden = false;

// Initialize header state
function initHeader() {
    header.addClass('nav-down');
    gsap.set(header, { y: 0 });
    initLogoSwitching();
}

// Initialize logo switching functionality
function initLogoSwitching() {
    const $logoLarge = $('[data-logo-large]');
    const $logoSmall = $('[data-logo-small]');
    
    if (!$logoLarge.length || !$logoSmall.length) {
        return;
    }
    
    // Check if altHeader is enabled - if so, show only small logo
    const isAltHeader = header.is('[data-header-alt]');
    
    if (isAltHeader) {
        // Show only small logo, hide large logo
        $logoLarge.hide();
        $logoSmall.show().css('opacity', '1');
        return; // Exit early, no switching functionality needed
    }
    
    // Check if we're on homepage
    const isHomepage = window.location.pathname === '/' || window.location.pathname === '';
    let currentLogoState = 'large'; // Track current state to avoid unnecessary transitions
    let isTransitioning = false; // Prevent multiple transitions at once
    
    // Increased scroll threshold for more leeway
    const scrollThreshold = 80; // Changed from 10 to 80
    
    function updateLogo(scrollTop) {
        if (isTransitioning) return; // Prevent multiple transitions
        
        // Check if mobile - always show small logo on mobile
        const isMobile = window.innerWidth < 1024;
        
        if (!isHomepage || isMobile) {
            // Not on homepage OR on mobile - always show small logo
            if (currentLogoState !== 'small') {
                showSmallLogo();
                currentLogoState = 'small';
            }
            return;
        }
        
        // On homepage desktop only - show large logo when at top, small when scrolled
        if (scrollTop <= scrollThreshold) {
            if (currentLogoState !== 'large') {
                showLargeLogo();
                currentLogoState = 'large';
            }
        } else {
            if (currentLogoState !== 'small') {
                showSmallLogo();
                currentLogoState = 'small';
            }
        }
    }
    
    function showLargeLogo() {
        isTransitioning = true;
        
        // Quick fade out small logo
        $logoSmall.css('opacity', '0');
        
        setTimeout(() => {
            $logoSmall.hide();
            $logoLarge.show().css('opacity', '0');
            
            // Quick fade in large logo
            setTimeout(() => {
                $logoLarge.css('opacity', '1');
                isTransitioning = false;
            }, 10);
        }, 150);
    }
    
    function showSmallLogo() {
        isTransitioning = true;
        
        // Quick fade out large logo
        $logoLarge.css('opacity', '0');
        
        setTimeout(() => {
            $logoLarge.hide();
            $logoSmall.show().css('opacity', '0');
            
            // Quick fade in small logo
            setTimeout(() => {
                $logoSmall.css('opacity', '1');
                isTransitioning = false;
            }, 10);
        }, 150);
    }
    
    // Initial logo state
    updateLogo(0);
    
    // Update logo on scroll
    lenis.on('scroll', (e) => {
        updateLogo(e.scroll);
    });
    
    // Handle window resize - update logo immediately
    $(window).on('resize', function() {
        // Force update logo on resize
        const currentScroll = lenis.scroll;
        updateLogo(currentScroll);
    });
}

// Update scroll handling to work with new Lenis setup
lenis.on('scroll', (e) => {
    const st = e.scroll;
    handleScroll(st);
});

function handleScroll(scrollTop) {
    // Don't hide header if mobile menu is open
    if ($('aside.mobile-menu').attr('data-menu-revealed') === 'true') {
        return;
    }
    
    // Only proceed if scroll difference is significant
    if (Math.abs(lastScrollTop - scrollTop) > delta) {
        
        if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
            // Scrolling down - hide header
            if (!isHeaderHidden) {
                hideHeader();
            }
        } else if (scrollTop < lastScrollTop) {
            // Scrolling up - show header
            if (isHeaderHidden) {
                showHeader();
            }
        }
        
        // Always show header when at the top
        if (scrollTop < 10) {
            if (isHeaderHidden) {
                showHeader();
            }
        }
    }
    
    lastScrollTop = scrollTop;
}

function hideHeader() {
    isHeaderHidden = true;
    header.removeClass('nav-down').addClass('nav-up');
    
    // Use GSAP for smooth animation
    gsap.to(header, {
        y: -header.outerHeight(),
        duration: 0.3,
        ease: "power2.out"
    });
}

function showHeader() {
    isHeaderHidden = false;
    header.removeClass('nav-up').addClass('nav-down');
    
    // Use GSAP for smooth animation
    gsap.to(header, {
        y: 0,
        duration: 0.3,
        ease: "power2.out"
    });
}

// Lenis animation is now handled by GSAP ticker


import ScrollOut from "scroll-out";

ScrollOut({
	cssProps: {
		viewportY: true,
	},
});




// READY

$(function () {

	console.log('Website proudly by Imagic Creative');

	// Initialize header animation
	initHeader();

	if ($('section[data-section="sliderType1"]').length) {
		setInterval(() => {
			var widgetNote = $('section[data-section="sliderType1"]').find('.es-main-content + script + a')
			widgetNote.remove();
		}, 100);
	}


	// MENU

	const supportsHover = window.matchMedia('(hover: hover)').matches;

	if (supportsHover) {
		$('.block-item[data-submenu]').hover(
			function () {
				const submenu = $(this).find('.block-submenu');
				fadeUp(submenu);
				$(this).find('.submenu-toggle').attr('aria-hidden','false');
			},
			function () {
				const submenu = $(this).find('.block-submenu');
				fadeDown(submenu);
				$(this).find('.submenu-toggle').attr('aria-hidden','true');
			}
		);
	} else {
		$('.submenu-toggle').on('click', function (e) {
			e.preventDefault();
			const submenu = $(this).siblings('.block-submenu');
			if (submenu.is(':visible')) {
				fadeDown(submenu);
				$(this).attr('aria-hidden','true');
			} else {
				fadeUp(submenu);
				$(this).attr('aria-hidden','false');
			}
			$(this).toggleClass('open');
		});
	}
	
	// MOVE TEAM POPUPS
	$('aside.teamCards-popup').each(function() {
        $('main').append(this);
    });


});

/////////////////////




// RESIZE

// $(window).on('resize', function() {
// 	checkLogoColor();
// });

////////////////////




// FORMS

$(function () {
	var forms = $('[data-freeform]');
	if (forms.length) {
		forms.each(function() {
			var formEl = $(this);
			initFormButton(formEl);
			formEl.on('freeform-ajax-success', function (event) {
				setTimeout(function() {
					initFormButton(formEl);
				}, 10);
			});
			formEl.on('freeform-ajax-error', function (event) {
				setTimeout(function() {
					initFormButton(formEl);
				}, 10);
			});
		})
	}
    $('textarea').on('input', function () {
        $(this).css('height', '187px'); // Reset height to calculate new scroll height
        if (this.scrollHeight > 187) {
            $(this).css('height', this.scrollHeight + 'px'); // Set height to match the content
        }
    });
});

function initFormButton(formEl) {
	var btn = formEl.find('button.freeform-button-submit');
	var btnText = btn.text();
	// if (btnText) {
	// 	var newText = '<span>' + btnText + '</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><g transform="translate(-425 5)"><rect width="40" height="40" rx="20" transform="translate(425 -5)" opacity="0"></rect><path d="M1.78,0,7.216,5.436,1.78,10.872M-8.784,5.436H6.591" transform="translate(441.71 10.538) rotate(-45)" fill="none" stroke="currentColor" stroke-width="2"></path></g></svg>';
	// 	btn.html(newText);
	// }
}

///////////////////////////////////////




// sliderType1

$(document).ready(function() {
    let triggers = $('[data-section="sliderType1"] [data-trigger]');
    let interval;

    function startInterval() {
        interval = setInterval(function() {
            // Find the current "revealed" trigger and start from the next one
            let currentIndex = triggers.index($('[data-section="sliderType1"] [data-trigger][data-revealed="true"]'));
            let nextIndex = (currentIndex + 1) % triggers.length;

            $(triggers[nextIndex]).trigger('click'); // Trigger click on the next block
        }, 7000);
    }

    function resetInterval() {
		if ($(window).width() >= 1280) {
			clearInterval(interval);
			startInterval();
		}
    }

    if ($(window).width() >= 1280) {
    	startInterval();
	}

	$(document).on('click', '[data-section="sliderType1"] [data-trigger]', function(e) {
		var section = $(this).closest('section');
		var othersTrigger = section.find('[data-trigger]');
		var othersContent = section.find('[data-trigger-content]');
		var othersImage = section.find('[data-trigger-image]');
		var revealed = $(this).attr('data-revealed');
		var uid = $(this).attr('data-trigger');
		var content = section.find('[data-trigger-content="' + uid + '"]');
		var image = section.find('[data-trigger-image="' + uid + '"]');
		if (revealed == 'false') {
			othersTrigger.attr('data-revealed','false');
			othersContent.slideUp(300);
			othersImage.attr('data-revealed','false');
			content.slideDown(300);
			$(this).attr('data-revealed','true');
			image.attr('data-revealed','true');
		}
	});

    // Pause on hover
    $(document).on('mouseenter', '[data-section="sliderType1"] [data-trigger]', function() {
        clearInterval(interval); // Pause
    }).on('mouseleave', '[data-section="sliderType1"] [data-trigger]', function() {
        resetInterval(); // Resume when hover ends
    });
});

///////////////////////////////////////




// LIST TYPE 1

$(document).on('click', '[data-section="listType1"] .list-heading', function(e) {
	var revealed = $(this).attr('data-revealed');
	if (revealed == 'false') {
		$(this).find('.link').text('Less');
		$(this).attr('data-revealed','true');
		$(this).parent().find('.list-content').slideDown(300);
	} else {
		$(this).find('.link').text('More');
		$(this).attr('data-revealed','false');
		$(this).parent().find('.list-content').slideUp(300);
	}
});

////////////////////




// FILTER - NEWS

let currentPage_N = 1;
let loading_N = false;
let currentCategory_N = 'all';
let cardsEl_N = $('section[data-section="filterNews"] .column-cards');
let loadMoreEl_N = $('section[data-section="filterNews"] [data-load-more]');

// Handle category filter click
$(document).on('click', 'section[data-section="filterNews"] [data-filter-trigger="category"]', function (e) {
    e.preventDefault();
    currentCategory_N = $(this).attr('data-filter-value');
    currentPage_N = 1;
    $('[data-filter-trigger="category"]').removeClass('active');
    $(this).addClass('active');
    cardsEl_N.empty();
	// console.log('currentPage_N ' + currentPage_N)
	// console.log('currentCategory_N ' + currentCategory_N)
    loadMoreNews(currentPage_N, currentCategory_N);

	//update url
	var currentUrl = window.location.href;
	currentUrl = decodeURIComponent(currentUrl);
	var url = new URL(currentUrl);
	url.searchParams.set('category', currentCategory_N);
	window.history.replaceState({}, document.title, url.toString());
});

function newsShowAll() {
	if (!$('[data-section="filterNews"]').length) 
		return null;

	var $sec = $('[data-section="filterNews"]');
	var $cardsRow = $sec.find('.row-cards');
	var $cards = $sec.find('.block-cta');

	if ($cards.length < 15)
		return null;

	$cards.slice(15).hide();

	// init btn
	var $btn = null;
	if ($sec.find('[data-load-more]').length) {
		$btn = $sec.find('[data-load-more]');
		$btn.fadeIn(200);
	} else  {
		$sec.find('.container').append(`<div class="row">
					<div class="column column-more">
						<button type="button" data-load-more>Show All</button>
					</div>
				</div>`);
		$btn = $sec.find('[data-load-more]');
	}
	
	$btn.click(function(e) {
		e.preventDefault();
		$cards.filter(':hidden').stop().fadeIn(400);
		$(this).fadeOut(200);
	})
}

$(document).ready(function(){
	newsShowAll();	
});


const newsFilterSection = $('section[data-section="filterNews"]');

$(function() {
	if (newsFilterSection.length) {
		var filter = getUrlParameter('category');
		var filterButton = newsFilterSection.find('[data-filter-value="' + filter + '"]');
		if (filterButton.length) {
			filterButton.trigger('click')
			
		}
	}
});

async function loadMoreNews(page, category = 'all') {
    try {
        const response = await $.ajax({
            type: 'get',
            url: `/news.json?page=${page}&category=${category}`,
        });
		let events = response.data;
        let limit = 8;
        if (events.length > 0) {
            events.forEach(function (event) {
                cardsEl_N.append(event.html);
				limit = event.limit;
            });
			newsShowAll();
			loading_N = false; // Allow loading more pages
        }
		// console.log('limit ' + limit)
		// console.log('events.length ' + events.length)
		if (events.length < limit || events.length == 0) {
            loadMoreEl_N.attr('data-load-more','false');
		} else {
            loadMoreEl_N.attr('data-load-more','true');
		}

    } catch (error) {
        console.log('Error loading more events:', error);
    }
}

////////////////////


////////////////////




// HELPERS

window.getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};  

function fadeUp($el, duration = 200) {
	$el.stop(true, true).css({
		opacity: 0,
		transform: 'translateY(10px)',
		display: 'flex'
	}).animate({
		opacity: 1
	}, {
		duration: duration,
		step: function (now, fx) {
			if (fx.prop === 'opacity') {
				$el.css('transform', `translateY(${(1 - now) * 10}px)`);
			}
		}
	});
}

function fadeDown($el, duration = 200) {
	$el.stop(true, true).animate({
		opacity: 0
	}, {
		duration: duration,
		step: function (now, fx) {
			if (fx.prop === 'opacity') {
				$el.css('transform', `translateY(${(1 - now) * 10}px)`);
			}
		},
		complete: function () {
			$el.css({ display: 'none' });
		}
	});
}

///////////////////////////////////////




// SECTION GALLERY POPUP

$(document).on('click', '[data-reveal-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'true');
	}
	var newHash = $(this).attr('data-reveal-gallery');
	if (newHash) {
		setTimeout(() => {
			window.location.hash = newHash;
		}, 150);
	}
});

$(document).on('click', '[data-hide-gallery]', function(e) {
	var aside = $('[data-gallery]');
	if (aside.length) {
		aside.attr('data-revealed', 'false');
	}
});

////////////////////////////////////////


$(document).on('click', '[data-popup-trigger]', function(e) {
	header.removeClass('nav-up nav-down');
	setTimeout(() => {
		header.removeClass('nav-up nav-down');
	}, 500);
	$('body').attr('data-menu-revealed','true');
	if ($('aside.main-menu').attr('data-menu-revealed') == 'true') {
		$('[data-menu-trigger]').trigger('click')
	}


	$('body').attr('data-menu-revealed','false');
	$('aside[data-popup]').attr('data-popup-revealed','false');
	$('[data-popup-trigger]').attr('data-popup-revealed','false');
	$('aside[data-popup]').attr('data-container-revealed','false');


	var uid = $(this).attr('data-popup-trigger');
	$(this).attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-popup-revealed','true');
	$('aside[data-popup="' + uid + '"]').attr('data-container-revealed','true');
	if ($(window).scrollTop() <= navbarHeight) {
		$('aside[data-popup="' + uid + '"]').attr('data-offset','true');
	} else {
		$('aside[data-popup="' + uid + '"]').attr('data-offset','false');
	}
	lenis.stop();
});

$(document).on('click', '[data-trigger-popup-close]', function(e) {
	header.removeClass('nav-up nav-down');
	$('body').attr('data-menu-revealed','false');
	$('aside[data-popup]').attr('data-popup-revealed','false');
	$('[data-popup-trigger]').attr('data-popup-revealed','false');
	// setTimeout(() => {
		$('aside[data-popup]').attr('data-container-revealed','false');
	// }, 1000);
	lenis.start();
});


/**
 *  HEADER LOGO CHANGE COLOR
 */

if ($('header .column-logo svg').length) {

	var darkSections = [
		'light',  
		'primary-three', 
		'primary-four',
		'primary-five',
		'primary-six',
		'secondary-four',
		'primary-one',
	];
	var lightSections = [
		'primary-two',
		'primary-seven',
	];

	// if ($('[data-section').length) {
	// 	checkLogoColor();
	// }
}

// function checkLogoColor() {
// 	var pos = $(window).scrollTop();

// 	$('section[data-section][data-bg]').each(function() {
// 		var $sec = $(this);
// 		var secTop = $sec.offset().top;
// 		var secBot = secTop + $sec.outerHeight();

// 		if (pos >= secTop && pos <= secBot) {
// 			//form type 1 white bg mob
// 			if ($sec.data('section') == 'formType1' && $(window).width() < 1024) {
// 				$('.headerContainer').attr('data-bg','primary-two')
// 				return false
// 			}

// 			var secBg = $sec.data('bg') ? $sec.data('bg') : 'light';
// 			if (lightSections.includes(secBg)) {
// 				$('.headerContainer').attr('data-bg','primary-seven')

// 				//text type 4
// 				if ($sec.data('section') == 'textType4' && $(window).width() > 1023)
// 					$('.headerContainer').addClass('texttype4');
// 				else
// 					$('.headerContainer').removeClass('texttype4');
// 			}
// 			else if (darkSections.includes(secBg)) {
// 				$('.headerContainer').attr('data-bg','primary-two')
// 			}
			
// 			return false;
// 		}
// 	});
// }



/**
 * TEXT TYPE 5 STICKY on mobile
 */
$(document).ready(handleStickyWrapping);
$(window).resize(debounce(handleStickyWrapping, 250));

function handleStickyWrapping() {
	var $tt4 = $('section[data-section="textType4"]');
	var $tt5 = $('section[data-section="textType5"]');

	if ($tt4.next('section[data-section="textType5"]').length > 0) {
		if ($(window).width() < 1025) {
			if (!$tt4.parent().hasClass('t45-wrap-sticky'))
				$tt4.add($tt5).wrapAll('<div class="t45-wrap-sticky"></div>');
		} else {
			if ($tt4.parent().hasClass('t45-wrap-sticky'))
				$tt4.parent('.t45-wrap-sticky').children().unwrap();
		}
	}
}

function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

///////////////////////////////////////

// sliderType2 section video handling

$(document).ready(function() {
	$('section[data-section="sliderType2"] .video-bg').each(function() {
		var $videoBg = $(this);
		var $placeholder = $videoBg.find('.placeholder-image');
		var $iframe = $videoBg.find('iframe');

		if (!$iframe.length) return;

		$iframe.css('opacity', '0');

		function revealBackground(delay) {
			setTimeout(function() {
				if ($placeholder.length) {
					$placeholder.fadeOut(500, function() {
						$iframe.css('opacity', '1');
					});
				} else {
					$iframe.css('opacity', '1');
				}
			}, delay);
		}

		if ($iframe.hasClass('youtube-bg')) {
			$iframe.on('load', function() {
				revealBackground(3000); // add delay for youtube
			});

			setTimeout(function() {
				revealBackground(0);
			}, 5000);
		} else if ($iframe.hasClass('vimeo-bg')) {
			$iframe.on('load', function() {
				revealBackground(1500);
			});

			setTimeout(function() {
				revealBackground(0);
			}, 4000);
		} else {
			revealBackground(0);
		}
	});
});

// sliderType2 slide media handling

$(document).ready(function() {
	$('section[data-section="sliderType2"] .swiper-slide').each(function() {
		var $slide = $(this);
		var $wrapper = $slide.find('[data-slide-video]');
		var $iframe = $wrapper.find('[data-slide-video-embed]');
		var $placeholder = $wrapper.find('.placeholder-image');

		if (!$wrapper.length || !$iframe.length) return;

		$iframe.css('opacity', '0');

		function revealVideo(delay) {
			setTimeout(function() {
				if ($placeholder.length) {
					$placeholder.fadeOut(500, function() {
						$iframe.css('opacity', '1');
					});
				} else {
					$iframe.css('opacity', '1');
				}
			}, delay);
		}

		if ($iframe.hasClass('youtube-bg')) {
			$iframe.on('load', function() {
				revealVideo(800);
			});

			setTimeout(function() {
				revealVideo(0);
			}, 5000);
		} else if ($iframe.hasClass('vimeo-bg')) {
			$iframe.on('load', function() {
				revealVideo(1500);
			});

			setTimeout(function() {
				revealVideo(0);
			}, 4000);
		} else {
			revealVideo(0);
		}
	});
});





/// MAP ANIMATIONS

// Hide map markers immediately (called right after marker creation)
window.hideMapMarkers = function(mapId, isInitialLoad = true) {
    const mapContainer = document.getElementById(mapId);
    if (!mapContainer) return;
    
    if (isInitialLoad) {
        mapContainer.classList.add('markers-hidden');
    }
};

// Map animation system
window.initMapAnimations = function(mapId, locationMarkers, clientMarkers) {
    if (typeof gsap === 'undefined') return;

    const mapContainer = document.getElementById(mapId);
    if (!mapContainer) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                animateMapMarkers(locationMarkers, clientMarkers, mapId);
                observer.unobserve(entry.target);
            }
        });
    }, {
        threshold: 0.3,
        rootMargin: '0px 0px -10% 0px'
    });

    observer.observe(mapContainer);
};


// Animate map markers with GSAP
function animateMapMarkers(locationMarkers, clientMarkers, mapId) {
    if (typeof gsap === 'undefined') return;

    animateLocationMarkers(locationMarkers, mapId).then(() => {
        setTimeout(() => {
            animateClientMarkers(clientMarkers, mapId);
        }, 200);
    });
}

// Animate location markers with pop-in effect
function animateLocationMarkers(locationMarkers, mapId) {
    return new Promise((resolve) => {
        if (!locationMarkers || locationMarkers.length === 0) {
            resolve();
            return;
        }

        const mapContainer = document.getElementById(mapId);
        if (!mapContainer) {
            resolve();
            return;
        }

        mapContainer.classList.remove('markers-hidden');
        mapContainer.classList.add('markers-animating');

        setTimeout(() => {
            const locationMarkerImages = mapContainer.querySelectorAll('img[src*="marker-locations"]');
            
            gsap.set(locationMarkerImages, {
                opacity: 0,
                scale: 0,
                transformOrigin: "center center"
            });

            if (locationMarkerImages.length === 0) {
                mapContainer.classList.remove('markers-hidden');
                mapContainer.classList.remove('markers-animating');
                resolve();
                return;
            }

            const tl = gsap.timeline({
                onComplete: () => {
                    mapContainer.classList.remove('markers-animating');
                    resolve();
                }
            });

            tl.to(locationMarkerImages, {
                opacity: 1,
                scale: 1,
                duration: 0.4,
                ease: "back.out(1.4)",
                stagger: 0.1
            });
        }, 100);
    });
}

// Animate client markers with pop-in effect
function animateClientMarkers(clientMarkers, mapId) {
    if (!clientMarkers || clientMarkers.length === 0) return;

    const mapContainer = document.getElementById(mapId);
    if (!mapContainer) return;

    setTimeout(() => {
        const clientMarkerImages = mapContainer.querySelectorAll('img[src*="marker-clients"]');
        
        if (clientMarkerImages.length === 0) {
            mapContainer.classList.remove('markers-hidden');
            return;
        }

        gsap.set(clientMarkerImages, {
            opacity: 0,
            scale: 0,
            transformOrigin: "center center"
        });

        const tl = gsap.timeline();

        tl.to(clientMarkerImages, {
            opacity: 1,
            scale: 1,
            duration: 0.3,
            ease: "back.out(1.4)",
            stagger: 0.05
        });
    }, 100);
}



/// BIG GRIN

// LISTING NEWS - STAGGERED ANIMATIONS AND PAGINATION

$(document).ready(function() {
    $('section[data-section="listingNews"]').each(function() {
        var $section = $(this);
        var $articlesContainer = $section.find('.news-grid');
        var $articles = $articlesContainer.find('.block-article');
        var $revealButton = $section.find('[data-reveal]');
        var totalArticles = $articles.length;
        var articlesPerPage = 12;
        var articlesPerLoad = 6;
        var currentPage = 1;
        var isAnimating = false;
        
        if (totalArticles === 0) return;
        
        // Initialize - show first 12 articles
        function initNewsListing() {
            // Hide all articles initially
            gsap.set($articles, {
                opacity: 0,
                y: 30,
                scale: 0.95
            });
            
            // Hide remaining articles
            $articles.slice(articlesPerPage).hide();
            
            // Show/hide reveal button based on remaining articles
            updateRevealButton();
            
            // Create scroll trigger for initial animation
            var initialArticles = $articles.slice(0, articlesPerPage);
            if (initialArticles.length > 0) {
                gsap.to(initialArticles, {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.6,
                    ease: "back.out(1.4)",
                    stagger: 0.1,
                    scrollTrigger: {
                        trigger: $section[0],
                        start: "top 60%",
                        end: "bottom 20%",
                        toggleActions: "play none none none",
                        once: true // Only trigger once
                    }
                });
            }
        }
        
        // Animate articles in with staggered bounce effect
        function animateArticlesIn($articlesToShow) {
            if (isAnimating) return;
            isAnimating = true;
            
            gsap.to($articlesToShow, {
                opacity: 1,
                y: 0,
                scale: 1,
                duration: 0.6,
                ease: "back.out(1.4)",
                stagger: 0.1, // 0.1 second delay between each article
                onComplete: function() {
                    isAnimating = false;
                }
            });
        }
        
        // Load more articles
        function loadMoreArticles() {
            if (isAnimating) return;
            
            var startIndex = currentPage * articlesPerPage;
            var endIndex = Math.min(startIndex + articlesPerLoad, totalArticles);
            var $newArticles = $articles.slice(startIndex, endIndex);
            
            if ($newArticles.length === 0) {
                // No more articles to load
                hideRevealButton();
                return;
            }
            
            // Show new articles
            $newArticles.show();
            
            // Animate new articles in
            gsap.fromTo($newArticles, 
                {
                    opacity: 0,
                    y: 30,
                    scale: 0.95
                },
                {
                    opacity: 1,
                    y: 0,
                    scale: 1,
                    duration: 0.6,
                    ease: "back.out(1.4)",
                    stagger: 0.1,
                    onComplete: function() {
                        currentPage++;
                        updateRevealButton();
                    }
                }
            );
        }
        
        // Update reveal button visibility
        function updateRevealButton() {
            var visibleCount = $articles.filter(':visible').length;
            if (visibleCount >= totalArticles) {
                hideRevealButton();
            } else {
                showRevealButton();
            }
        }
        
        // Hide reveal button with fade out
        function hideRevealButton() {
            gsap.to($revealButton, {
                opacity: 0,
                duration: 0.3,
                ease: "power2.out",
                onComplete: function() {
                    $revealButton.hide();
                }
            });
        }
        
        // Show reveal button with fade in
        function showRevealButton() {
            $revealButton.show();
            gsap.to($revealButton, {
                opacity: 1,
                duration: 0.3,
                ease: "power2.out"
            });
        }
        
        // Click handler for reveal button
        $revealButton.on('click', function(e) {
            e.preventDefault();
            loadMoreArticles();
        });
        
        // Initialize the component
        initNewsListing();
    });
});

// TEXT TYPE 3 - TABS ONLY (accordion moved to textType4)

$(document).ready(function() {
    $('section[data-section="textType3"]').each(function() {
        var $section = $(this);
        var $tabs = $section.find('.block-tab');
        var $tabContents = $section.find('.tab-content');

        // Initialize tabs - check URL parameter first, otherwise show first tab
        function initTabs() {
            $tabContents.hide();
            $tabs.removeClass('active');

            if ($tabContents.length > 0) {
                var defaultTabIndex = 0;
                
                // Check for tab parameter in URL
                var urlParams = new URLSearchParams(window.location.search);
                var tabParam = urlParams.get('tab');
                
                if (tabParam) {
                    var requestedTabIndex = parseInt(tabParam) - 1; // Convert to 0-based index
                    
                    // Validate tab index (must be within bounds)
                    if (requestedTabIndex >= 0 && requestedTabIndex < $tabs.length) {
                        defaultTabIndex = requestedTabIndex;
                    }
                }
                
                // Show the determined tab
                showTab(defaultTabIndex, false); // false = no animation on initial load
            }
        }
        
        // Function to show a specific tab with optional animation
        function showTab(tabIndex, animate) {
            var $targetTab = $tabs.eq(tabIndex);
            var $targetContent = $tabContents.eq(tabIndex);
            
            // Don't do anything if this tab is already active
            if ($targetTab.hasClass('active')) return;
            
            // Remove active class and position classes from all tabs
            $tabs.removeClass('active tab-back tab-front');
            
            // Add active class to target tab
            $targetTab.addClass('active');
            
            // Add position classes to other tabs based on their position relative to active tab
            $tabs.each(function(index) {
                var $tab = $(this);
                if (index < tabIndex) {
                    // Tabs before active tab get tab-back class
                    $tab.addClass('tab-back');
                } else if (index > tabIndex) {
                    // Tabs after active tab get tab-front class
                    $tab.addClass('tab-front');
                }
                // Active tab (index === tabIndex) gets no additional class
            });
            
            // Hide all tab contents
            $tabContents.hide();
            
            if (animate !== false) {
                // Show target content with pop-in animation
                $targetContent.css({
                    opacity: 0,
                    transform: 'translateY(10px) scale(0.95)'
                }).show().animate({
                    opacity: 1
                }, {
                    duration: 400,
                    easing: 'swing',
                    step: function(now, fx) {
                        if (fx.prop === 'opacity') {
                            var progress = now;
                            var translateY = (1 - progress) * 10;
                            var scale = 0.95 + (progress * 0.05);
                            $targetContent.css('transform', `translateY(${translateY}px) scale(${scale})`);
                        }
                    },
                    complete: function() {
                        $targetContent.css('transform', 'translateY(0) scale(1)');
                    }
                });
            } else {
                // Show immediately without animation
                $targetContent.show();
            }
        }
        
        // Tab click handler
        $tabs.on('click', function(e) {
            e.preventDefault();
            
            var tabIndex = $tabs.index(this);
            showTab(tabIndex, true); // true = animate on click
        });
        
        // Initialize tabs
        initTabs();
        
        // Handle URL parameter changes (for links with ?tab=X)
        function handleTabParameter() {
            var urlParams = new URLSearchParams(window.location.search);
            var tabParam = urlParams.get('tab');
            
            if (tabParam) {
                var requestedTabIndex = parseInt(tabParam) - 1; // Convert to 0-based index
                
                // Validate tab index (must be within bounds)
                if (requestedTabIndex >= 0 && requestedTabIndex < $tabs.length) {
                    showTab(requestedTabIndex, true); // true = animate
                }
            }
        }
        
        // Handle tab parameter on page load and when hash changes
        $(window).on('hashchange', function() {
            handleTabParameter();
        });
        
        // Handle tab parameter when clicking on links with ?tab=
        $(document).on('click', 'a[href*="?tab="]', function(e) {
            // Let the default link behavior happen first, then handle tab parameter
            setTimeout(function() {
                handleTabParameter();
            }, 100);
        });
    });
});

// FORM TYPE 2 - SUCCESS MESSAGE HANDLING

$(document).ready(function() {
    $('section[data-section="formType2"]').each(function() {
        var $section = $(this);
        var $formWrapper = $section.find('.form-wrapper');
        var $thankYouWrapper = $section.find('.thankyou-wrapper');
        var $form = $section.find('form');
        var $intro = $section.find('.intro');
        
        // Check for success parameter in URL
        function checkForSuccess() {
            var urlParams = new URLSearchParams(window.location.search);
            var successParam = urlParams.get('success');
            
            if (successParam === '1') {
                // Hide form and intro, show thank you message
                $form.hide();
                $intro.hide();
                $thankYouWrapper.removeClass('hidden').show();
                
                // Add animation classes for bouncy pop-in effect
                $thankYouWrapper.css({
                    opacity: 0,
                    transform: 'scale(0.8) translateY(20px)'
                });
                
                // Scroll to the form section first
                setTimeout(function() {
                    // Use Lenis for smooth scrolling to the form section
                    lenis.scrollTo($section[0], {
                        duration: 1.2,
                        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
                        offset: -100 // Offset to account for fixed header
                    });
                }, 200); // Small delay to let page settle
                
                // Animate in with bouncy effect after scroll
                gsap.to($thankYouWrapper, {
                    opacity: 1,
                    scale: 1,
                    y: 0,
                    duration: 0.8,
                    ease: "back.out(1.7)",
                    delay: 1.5
                });
            }
        }
        
        // Check on page load
        checkForSuccess();
        
        // Also check when URL changes (for dynamic navigation)
        $(window).on('hashchange', function() {
            checkForSuccess();
        });
        
        // Handle clicks on links with success parameter
        $(document).on('click', 'a[href*="success=1"]', function(e) {
            setTimeout(function() {
                checkForSuccess();
            }, 100);
        });
    });
});
// TEXT TYPE 4 - ACCORDION (standalone)

$(document).ready(function() {
    $('section[data-section="textType4"]').each(function() {
        var $section = $(this);
        var $items = $section.find('.accordion-item');

        // Initialize accordion based on screen size
        function initAccordion() {
            var isMobile = window.innerWidth <= 1023;
            
            $items.each(function(index) {
                var $item = $(this);
                var $content = $item.find('.acc-content');
                var $toggle = $item.find('.acc-toggle');

                // Desktop: open first item by default, others closed
                // Mobile: all items closed by default
                if (!isMobile && index === 0) {
                    $item.addClass('open');
                    $toggle.addClass('active');
                    $content.css({ display: 'block', height: 'auto' });
                } else {
                    $item.removeClass('open');
                    $toggle.removeClass('active');
                    $content.css({ display: 'none', height: 0 });
                }
            });
        }
        
        // Initialize accordion
        initAccordion();
        
        // Handle window resize - reinitialize accordion when switching between mobile/desktop
        $(window).on('resize', function() {
            initAccordion();
        });

        // Click handler - multiple items can be open at the same time
        $section.on('click', '.acc-toggle', function(e) {
            e.preventDefault();

            var $item = $(this).closest('.accordion-item');
            var $content = $item.find('.acc-content');
            var $toggle = $(this);
            var isOpen = $item.hasClass('open');

            if (isOpen) {
                // Close
                $item.removeClass('open');
                $toggle.removeClass('active');
                gsap.to($content, {
                    height: 0,
                    duration: 0.4,
                    ease: 'back.in(1.4)',
                    onComplete: function() {
                        $content.css('display', 'none');
                    }
                });
            } else {
                // Open
                $item.addClass('open');
                $toggle.addClass('active');
                $content.css('display', 'block');
                gsap.fromTo($content,
                    { height: 0 },
                    {
                        height: 'auto',
                        duration: 0.4,
                        ease: 'back.out(1.4)'
                    }
                );
            }
        });
    });
});

// MENU MOBILE

$(document).on('click', '[data-menu-trigger]', function(e) {
	var revealed = $(this).attr('data-menu-revealed');
	if (revealed == 'false') {
		$(this).attr('data-menu-revealed','true');
		$('aside.mobile-menu').attr('data-menu-revealed','true');
		$('aside.mobile-menu').stop().slideDown(600);
		lenis.stop();
	} else {
		$(this).attr('data-menu-revealed','false');
		$('aside.mobile-menu').attr('data-menu-revealed','false');
		$('aside.mobile-menu').stop().slideUp(600);
		lenis.start();
		
		// Reset header state when mobile menu closes
		setTimeout(() => {
			if (isHeaderHidden) {
				showHeader();
			}
		}, 100);
	}
});



// NAV DOWN
$(document).on('click', '[data-nav-down]', function(e) {
	e.preventDefault();
	
	var $currentSection = $(this).closest('section');
	var $nextSec = $currentSection.next('section, div.pin-spacer');

    console.log($nextSec.length);
	
	if (!$nextSec.length) return;
	
	// Use Lenis for smooth scrolling
	lenis.scrollTo($nextSec[0], {
		duration: 2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
		offset: 0
	});
})

// SCROLL TO ELEMENT BY ID FROM HASH
// Handles links with #VALUEHERE and scrolls to element with id="VALUEHERE"
function handleHashScroll() {
	const hash = window.location.hash.substring(1); // Remove the # symbol
	
	if (hash) {
		const $targetElement = $('#' + hash);
		
		if ($targetElement.length) {
			// Use Lenis for smooth scrolling
			lenis.scrollTo($targetElement[0], {
				duration: 2,
				easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // easeOutExpo
				offset: -100 // Offset to account for fixed header
			});
		} else {
			console.warn('Element with id "' + hash + '" not found');
		}
	}
}

// Handle hash scroll on page load
$(document).ready(function() {
	handleHashScroll();
});

// Handle hash scroll when hash changes
$(window).on('hashchange', function() {
	handleHashScroll();
});

// Handle hash scroll when clicking on hash links
$(document).on('click', 'a[href^="#"]', function(e) {
	const href = $(this).attr('href');
	if (href && href !== '#') {
		e.preventDefault();
		const hash = href.substring(1); // Remove the # symbol
		
		// Update URL hash
		window.location.hash = hash;
		
		// Handle scroll
		setTimeout(function() {
			handleHashScroll();
		}, 100);
	}
});


///////////////////////////////////////
// FORM CHECKBOX ACTIVE STATE TOGGLE

$(document).ready(function() {
    function getAssociatedLabel($checkbox) {
        // Prefer a wrapping label
        var $label = $checkbox.closest('label');
        if ($label.length) return $label;
        // Otherwise, find label by for="id"
        var id = $checkbox.attr('id');
        if (id) {
            var $byFor = $('label[for="' + id + '"]');
            if ($byFor.length) return $byFor;
        }
        // Fallback: look for nearest .freeform-label in the same field container
        return $checkbox.closest('[class*="freeform-fieldtype-"]').find('label.freeform-label').first();
    }

    // Handle checkbox changes for active state (wrapping labels and single checkboxes)
    $(document).on('change', 'form input[type="checkbox"]', function() {
        var $checkbox = $(this);
        var $label = getAssociatedLabel($checkbox);
        if (!$label.length) return;
        if ($checkbox.is(':checked')) {
            $label.addClass('active');
        } else {
            $label.removeClass('active');
        }
    });
    
    // Initialize active state for any pre-checked checkboxes
    $('form input[type="checkbox"]:checked').each(function() {
        var $label = getAssociatedLabel($(this));
        if ($label.length) $label.addClass('active');
    });
});

///////////////////////////////////////
// CUSTOM SELECT CHEVRON

$(document).ready(function() {
    // Wrap selects with a container and append chevron if not already done
    $('form select.freeform-input').each(function() {
        var $select = $(this);
        if ($select.parent('.select-wrapper').length) return;
        var $wrapper = $('<div class="select-wrapper"></div>');
        $select.wrap($wrapper);
        $select.after('<span class="select-chevron" aria-hidden="true"></span>');
    });

    // Toggle open state to rotate the chevron
    $(document).on('focus mousedown', 'form select.freeform-input', function() {
        $(this).closest('.select-wrapper').addClass('open');
    });
    function closeSelect($el){
        var $wrap = $el.closest('.select-wrapper');
        setTimeout(function(){ $wrap.removeClass('open'); }, 50);
    }
    $(document).on('change blur keydown mouseup', 'form select.freeform-input', function(e) {
        if (e.type === 'keydown' && e.key !== 'Escape' && e.key !== 'Enter') return;
        closeSelect($(this));
    });
    // Clicks outside should close any open chevrons
    $(document).on('click touchstart', function(e){
        if (!$(e.target).closest('.select-wrapper').length) {
            $('.select-wrapper').removeClass('open');
        }
    });
});

///////////////////////////////////////
// COMPONENT VIDEO - descriptionRichVideo

$(document).on('click', '[data-video-trigger]', function(e) {
	e.preventDefault();
	
	var $container = $(this).closest('[data-video-component]');
	var $placeholder = $container.find('.video-placeholder');
	var $iframeContainer = $container.find('.video-iframe-container');
	var $iframe = $iframeContainer.find('iframe[data-iframe-src]');
	var iframeSrc = $iframe.attr('data-iframe-src');
	
	if (!iframeSrc) return;
	
	// Load the iframe if not already loaded
	if (!$iframe.attr('src')) {
		$iframe.attr('src', iframeSrc);
	}
	
	// Show iframe container
	$iframeContainer.css('display', 'block');
	
	// Fade out placeholder
	$placeholder.animate({
		opacity: 0
	}, 400, function() {
		$placeholder.hide();
		
		// Fade in iframe after placeholder is hidden
		$iframe.animate({
			opacity: 1
		}, 300);
	});
	
	// Show iframe with fade in after it loads
	$iframe.on('load', function() {
		setTimeout(function() {
			$iframe.animate({
				opacity: 1
			}, 300);
		}, 300);
	});
	
	// Fallback in case load event doesn't fire
	setTimeout(function() {
		$iframe.animate({
			opacity: 1
		}, 300);
	}, 2000);
});

///////////////////////////////////////
// VIDEO POPUP - ctaType1

$(document).on('click', '[data-video-popup-trigger]', function(e) {
	e.preventDefault();
	
	// Get the popup ID from the trigger
	var popupId = $(this).attr('data-video-popup-trigger');
	
	// Find the matching aside
	var $popup = $('aside[data-video-popup][data-popup-id="' + popupId + '"]');
	
	if (!$popup.length) return;
	
	// Get the iframe inside this popup
	var $iframe = $popup.find('iframe[data-iframe-src]');
	var iframeSrc = $iframe.attr('data-iframe-src');
	
	// Stop scrolling
	lenis.stop();
	
	// Show popup with fade animation
	$popup.css({
		opacity: 0,
		display: 'flex'
	}).animate({
		opacity: 1
	}, 400);
	
	// Load the iframe if not already loaded
	if (iframeSrc && !$iframe.attr('src')) {
		$iframe.attr('src', iframeSrc);
		
		// Show iframe with fade in after it loads
		$iframe.on('load', function() {
			setTimeout(function() {
				$iframe.css('opacity', '1');
			}, 300);
		});
		
		// Fallback in case load event doesn't fire
		setTimeout(function() {
			$iframe.css('opacity', '1');
		}, 2000);
	} else if ($iframe.attr('src')) {
		// Already loaded, just show it
		$iframe.css('opacity', '1');
	}
});

// Close video popup
$(document).on('click', '[data-popup-close]', function(e) {
	e.preventDefault();
	
	// Find the parent popup
	var $popup = $(this).closest('aside[data-video-popup]');
	
	if (!$popup.length) return;
	
	// Get the iframe
	var $iframe = $popup.find('iframe');
	
	// Fade out popup
	$popup.animate({
		opacity: 0
	}, 400, function() {
		$popup.css('display', 'none');
		
		// Remove iframe src to stop video and reset for next open
		if ($iframe.length) {
			$iframe.attr('src', '');
			$iframe.css('opacity', '0');
		}
	});
	
	// Restart scrolling
	lenis.start();
});

// Close popup when clicking on the backdrop (outside video container)
$(document).on('click', 'aside[data-video-popup]', function(e) {
	// Only close if clicking directly on the aside (not on children)
	if (e.target === this) {
		$(this).find('[data-popup-close]').trigger('click');
	}
});

// Close popup with ESC key
$(document).on('keydown', function(e) {
	if (e.key === 'Escape' || e.keyCode === 27) {
		var $openPopup = $('aside[data-video-popup]').filter(function() {
			return $(this).css('display') !== 'none';
		});
		
		if ($openPopup.length) {
			$openPopup.find('[data-popup-close]').trigger('click');
		}
	}
});


///////////////////////////////////////
// TESTIMONIALS FADE TRANSITION - textType1

$(document).ready(function() {
    $('[data-testimonials-slider]').each(function() {
        var $slider = $(this);
        var $container = $slider.find('[data-reviews-container]');
        var $reviews = $slider.find('[data-review-item]');
        var totalReviews = $reviews.length;
        
        // Responsive reviews per set based on screen size
        function getReviewsPerSet() {
            if (window.innerWidth < 640) {
                return 1; // Mobile: show 1 review
            } else if (window.innerWidth < 1024) {
                return 2; // Tablet: show 2 reviews
            } else {
                return 3; // Desktop: show 3 reviews
            }
        }
        
        var reviewsPerSet = getReviewsPerSet();
        
        if (totalReviews <= reviewsPerSet) return; // No need to transition if not enough reviews
        
        var totalSets = Math.ceil(totalReviews / reviewsPerSet);
        var currentSet = 0;
        var autoplayTimer = null; // Using GSAP delayedCall for consistent timing
        var isTransitioning = false;
        var isPaused = false;
        var cycleDuration = 4; // Total cycle time: 4 seconds
        
        //PREVENT LAYOUT SHIFT
        function calculateAndSetMinHeight(reviewSets) {
            // Store current container state
            var currentContent = $container.html();
            var containerWidth = $container.width();
            
            // If container width is 0 (not yet rendered), use parent width or wait
            if (containerWidth === 0) {
                containerWidth = $container.parent().width() || '100%';
            }
            
            // Create a temporary container with same styling context
            var $tempContainer = $('<div>').addClass($container.attr('class') || '').css({
                position: 'absolute',
                visibility: 'hidden',
                top: '-9999px',
                left: '-9999px',
                width: containerWidth
            });
            $container.parent().append($tempContainer);
            
            var maxHeight = 0;
            
            // Measure each review set's height
            reviewSets.forEach(function($set) {
                // Clone the set and add to temp container
                var $clonedSet = $set.clone(true); // Clone with data and events
                $tempContainer.empty().append($clonedSet);
                
                // Force a reflow to ensure accurate measurement
                $tempContainer[0].offsetHeight;
                
                // Measure the height
                var setHeight = $tempContainer.outerHeight(true); // Include margins
                if (setHeight > maxHeight) {
                    maxHeight = setHeight;
                }
            });
            
            // Remove temp container
            $tempContainer.remove();
            
            // Restore original content (in case it was modified)
            $container.html(currentContent);
            
            // Set min-height on the container to prevent layout shift
            if (maxHeight > 0) {
                $container.css('min-height', maxHeight + 'px');
            }
        }
        
        function initFadeTransition() {
            // Create review sets
            var reviewSets = [];
            for (var i = 0; i < totalSets; i++) {
                var startIndex = i * reviewsPerSet;
                var endIndex = Math.min(startIndex + reviewsPerSet, totalReviews);
                reviewSets.push($reviews.slice(startIndex, endIndex));
            }
            
            // Store all sets for later use
            $slider.data('reviewSets', reviewSets);
            
            // Calculate and set min-height based on tallest review set
            calculateAndSetMinHeight(reviewSets);
            
            // Show first set immediately
            showSet(0, true); // Pass true to skip animation on first load
            
            // Start auto-transition timer
            startAutoTransition();
        }
        
        function showSet(setIndex, skipAnimation) {
            var reviewSets = $slider.data('reviewSets');
            var $currentSet = reviewSets[setIndex];
            
            // Clear container and add current set
            $container.empty();
            $currentSet.appendTo($container);
            
            if (skipAnimation) {
                // Just show without animation
                gsap.set($currentSet, { opacity: 1, y: 0, scale: 1 });
            } else {
                // Animate in with staggered bounce effect
                gsap.fromTo($currentSet, 
                    {
                        opacity: 0,
                        y: 30,
                        scale: 0.95
                    },
                    {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.6,
                        ease: "back.out(1.4)",
                        stagger: 0.15
                    }
                );
            }
        }
        
        function transitionToNextSet() {
            // Don't transition if paused or already transitioning
            if (isPaused || isTransitioning) return;
            
            isTransitioning = true;
            
            var nextIndex = (currentSet + 1) % totalSets;
            var $currentReviews = $container.find('[data-review-item]');
            
            // Fade out current set with staggered effect
            gsap.to($currentReviews, {
                opacity: 0,
                y: -20,
                scale: 0.95,
                duration: 0.4,
                ease: "back.in(1.2)",
                stagger: 0.1,
                onComplete: function() {
                    // Show next set
                    showSet(nextIndex, false);
                    currentSet = nextIndex;
                    isTransitioning = false;
                }
            });
            
            // Schedule next transition - consistently every 4 seconds
            startAutoTransition();
        }
        
        function startAutoTransition() {
            // Kill any existing timer
            if (autoplayTimer) {
                autoplayTimer.kill();
            }
            
            // Don't start if paused
            if (isPaused) return;
            
            // Use GSAP delayedCall for precise, consistent timing
            autoplayTimer = gsap.delayedCall(cycleDuration, transitionToNextSet);
        }
        
        function stopAutoTransition() {
            isPaused = true;
            if (autoplayTimer) {
                autoplayTimer.kill();
                autoplayTimer = null;
            }
        }
        
        function resumeAutoTransition() {
            isPaused = false;
            // Only resume if not currently transitioning
            if (!isTransitioning) {
                startAutoTransition();
            }
        }
        
        // Pause on hover
        $slider.hover(
            function() {
                stopAutoTransition();
            },
            function() {
                resumeAutoTransition();
            }
        );
        
        // Initialize the fade transition
        initFadeTransition();
        
        // Handle window resize - update reviews per set
        var currentAnimation = autoplayTimer;
        $(window).on('resize', function() {
            var newReviewsPerSet = getReviewsPerSet();
            
            // Only restart if the reviews per set changed
            if (newReviewsPerSet !== reviewsPerSet) {
                reviewsPerSet = newReviewsPerSet;
                totalSets = Math.ceil(totalReviews / reviewsPerSet);
                
                // Kill current animation
                if (currentAnimation) {
                    currentAnimation.kill();
                }
                
                // Reset to first set
                currentSet = 0;
                isTransitioning = false;
                isPaused = false;
                
                // Reinitialize with new settings
                initFadeTransition();
            }
        });
    });
});

///////////////////////////////////////
// CARDS TYPE 2 - MOBILE SLIDER (cardsType2)

$(document).ready(function() {
    $('[data-cards-slider]').each(function() {
        var $slider = $(this);
        var $container = $slider.find('[data-services-container]');
        var $services = $slider.find('[data-service-item]');
        var totalServices = $services.length;
        
        // Get cards per slide based on screen size
        function getCardsPerSlide() {
            if (window.innerWidth < 500) {
                return 1; // Mobile: 1 card
            } else if (window.innerWidth < 1024) {
                return 2; // Tablet: 2 cards
            } else {
                return 3; // Desktop: 3 cards
            }
        }
        
        // Check if slider should be active
        function shouldActivateSlider() {
            var cardsPerSlide = getCardsPerSlide();
            // Don't activate if there are 3 or fewer cards on desktop (no need to slide)
            if (window.innerWidth >= 1024 && totalServices <= 3) {
                return false;
            }
            // Don't activate if there's only 1 card total
            if (totalServices <= 1) {
                return false;
            }
            return true;
        }
        
        // Always create pagination if there are multiple slides
        var cardsPerSlide = getCardsPerSlide();
        var totalSets = Math.ceil(totalServices / cardsPerSlide);
        
        if (totalSets > 1) {
            createPagination(totalSets);
        }
        
        if (!shouldActivateSlider()) return;
        
        var currentIndex = 0;
        var autoplayTimer = null;
        var isTransitioning = false;
        var isPaused = false;
        var cycleDuration = 4; // 4 seconds per slide
        
        function initSlider() {
            var cardsPerSlide = getCardsPerSlide();
            var totalSets = Math.ceil(totalServices / cardsPerSlide);
            
            // Create service sets based on cards per slide
            var serviceSets = [];
            for (var i = 0; i < totalSets; i++) {
                var startIndex = i * cardsPerSlide;
                var endIndex = Math.min(startIndex + cardsPerSlide, totalServices);
                serviceSets.push($services.slice(startIndex, endIndex));
            }
            
            // Store sets for later use
            $slider.data('serviceSets', serviceSets);
            
            // Show first set immediately
            showServiceSet(0, true);
            
            // Start auto-transition
            startAutoTransition();
        }
        
        function createPagination(totalSets) {
            var $pagination = $slider.find('[data-cards-pagination]');
            $pagination.empty();
            
            for (var i = 0; i < totalSets; i++) {
                var $dot = $('<div class="pagination-dot" data-page="' + i + '"></div>');
                if (i === 0) $dot.addClass('active');
                $pagination.append($dot);
            }
            
            // Add click handlers for pagination dots
            $pagination.on('click', '.pagination-dot', function() {
                var pageIndex = parseInt($(this).data('page'));
                showServiceSet(pageIndex, true);
                currentIndex = pageIndex;
                
                // Restart auto-transition from this point
                startAutoTransition();
            });
        }
        
        function showServiceSet(setIndex, skipAnimation) {
            var serviceSets = $slider.data('serviceSets');
            var $currentSet = serviceSets[setIndex];
            
            // Update pagination dots immediately for instant feedback
            $slider.find('.pagination-dot').removeClass('active');
            $slider.find('.pagination-dot[data-page="' + setIndex + '"]').addClass('active');
            
            // Clear container and add current set
            $container.empty();
            $currentSet.appendTo($container);
            
            if (skipAnimation) {
                gsap.set($currentSet, { opacity: 1, y: 0, scale: 1 });
            } else {
                // Animate in with same easing as testimonials
                gsap.fromTo($currentSet, 
                    {
                        opacity: 0,
                        y: 30,
                        scale: 0.95
                    },
                    {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.6,
                        ease: "back.out(1.4)",
                        stagger: 0.1
                    }
                );
            }
        }
        
        function transitionToNextSet() {
            if (isTransitioning || isPaused) return;
            
            isTransitioning = true;
            var serviceSets = $slider.data('serviceSets');
            var totalSets = serviceSets.length;
            var nextIndex = (currentIndex + 1) % totalSets;
            var $currentSet = $container.find('[data-service-item]');
            
            // Animate out
            gsap.to($currentSet, {
                opacity: 0,
                y: -30,
                scale: 0.95,
                duration: 0.4,
                ease: "back.in(1.2)",
                stagger: 0.05,
                onComplete: function() {
                    // Show next set
                    showServiceSet(nextIndex, false);
                    currentIndex = nextIndex;
                    isTransitioning = false;
                }
            });
            
            // Schedule next transition
            startAutoTransition();
        }
        
        function startAutoTransition() {
            if (autoplayTimer) {
                autoplayTimer.kill();
            }
            
            if (isPaused) return;
            
            autoplayTimer = gsap.delayedCall(cycleDuration, transitionToNextSet);
        }
        
        function stopAutoTransition() {
            isPaused = true;
            if (autoplayTimer) {
                autoplayTimer.kill();
                autoplayTimer = null;
            }
        }
        
        function resumeAutoTransition() {
            isPaused = false;
            if (!isTransitioning) {
                startAutoTransition();
            }
        }
        
        // Pause on hover
        $slider.hover(
            function() { stopAutoTransition(); },
            function() { resumeAutoTransition(); }
        );
        
        // Initialize slider
        initSlider();
        
        // Handle window resize
        $(window).on('resize', function() {
            var newCardsPerSlide = getCardsPerSlide();
            var newShouldActivate = shouldActivateSlider();
            
            // Kill current timer
            if (autoplayTimer) {
                autoplayTimer.kill();
                autoplayTimer = null;
            }
            
            if (!newShouldActivate) {
                // Show all services without slider
                $container.empty();
                $services.appendTo($container);
            } else {
                // Reinitialize slider with new settings
                currentIndex = 0;
                isTransitioning = false;
                isPaused = false;
                initSlider();
            }
        });
    });
});

///////////////////////////////////////
// NEWS SLIDER - MOBILE SLIDER (relevant-news)

$(document).ready(function() {
    $('[data-news-slider]').each(function() {
        var $slider = $(this);
        var $container = $slider.find('[data-news-container]');
        var $newsItems = $slider.find('[data-news-item]');
        var totalNews = $newsItems.length;
        
        // Get cards per slide based on screen size
        function getCardsPerSlide() {
            if (window.innerWidth < 500) {
                return 1; // Mobile: 1 card
            } else if (window.innerWidth < 1024) {
                return 2; // Tablet: 2 cards
            } else {
                return 3; // Desktop: 3 cards
            }
        }
        
        // Check if slider should be active
        function shouldActivateSlider() {
            var cardsPerSlide = getCardsPerSlide();
            // Don't activate if there are 3 or fewer cards on desktop (no need to slide)
            if (window.innerWidth >= 1024 && totalNews <= 3) {
                return false;
            }
            // Don't activate if there's only 1 card total
            if (totalNews <= 1) {
                return false;
            }
            return true;
        }
        
        // Always create pagination if there are multiple slides
        var cardsPerSlide = getCardsPerSlide();
        var totalSets = Math.ceil(totalNews / cardsPerSlide);
        
        if (totalSets > 1) {
            createPagination(totalSets);
        }
        
        if (!shouldActivateSlider()) return;
        
        var currentIndex = 0;
        var autoplayTimer = null;
        var isTransitioning = false;
        var isPaused = false;
        var cycleDuration = 4; // 4 seconds per slide
        
        function initSlider() {
            var cardsPerSlide = getCardsPerSlide();
            var totalSets = Math.ceil(totalNews / cardsPerSlide);
            
            // Create news sets based on cards per slide
            var newsSets = [];
            for (var i = 0; i < totalSets; i++) {
                var startIndex = i * cardsPerSlide;
                var endIndex = Math.min(startIndex + cardsPerSlide, totalNews);
                newsSets.push($newsItems.slice(startIndex, endIndex));
            }
            
            // Store sets for later use
            $slider.data('newsSets', newsSets);
            
            // Show first set immediately
            showNewsSet(0, true);
            
            // Start auto-transition
            startAutoTransition();
        }
        
        function createPagination(totalSets) {
            var $pagination = $slider.find('[data-news-pagination]');
            $pagination.empty();
            
            for (var i = 0; i < totalSets; i++) {
                var $dot = $('<div class="pagination-dot" data-page="' + i + '"></div>');
                if (i === 0) $dot.addClass('active');
                $pagination.append($dot);
            }
            
            // Add click handlers for pagination dots
            $pagination.on('click', '.pagination-dot', function() {
                var pageIndex = parseInt($(this).data('page'));
                showNewsSet(pageIndex, true);
                currentIndex = pageIndex;
                
                // Restart auto-transition from this point
                startAutoTransition();
            });
        }
        
        function showNewsSet(setIndex, skipAnimation) {
            var newsSets = $slider.data('newsSets');
            var $currentSet = newsSets[setIndex];
            
            // Update pagination dots immediately for instant feedback
            $slider.find('.pagination-dot').removeClass('active');
            $slider.find('.pagination-dot[data-page="' + setIndex + '"]').addClass('active');
            
            // Clear container and add current set
            $container.empty();
            $currentSet.appendTo($container);
            
            if (skipAnimation) {
                gsap.set($currentSet, { opacity: 1, y: 0, scale: 1 });
            } else {
                // Animate in with same easing as testimonials
                gsap.fromTo($currentSet, 
                    {
                        opacity: 0,
                        y: 30,
                        scale: 0.95
                    },
                    {
                        opacity: 1,
                        y: 0,
                        scale: 1,
                        duration: 0.6,
                        ease: "back.out(1.4)",
                        stagger: 0.1
                    }
                );
            }
        }
        
        function transitionToNextSet() {
            if (isTransitioning || isPaused) return;
            
            isTransitioning = true;
            var newsSets = $slider.data('newsSets');
            var totalSets = newsSets.length;
            var nextIndex = (currentIndex + 1) % totalSets;
            var $currentSet = $container.find('[data-news-item]');
            
            // Animate out
            gsap.to($currentSet, {
                opacity: 0,
                y: -30,
                scale: 0.95,
                duration: 0.4,
                ease: "back.in(1.2)",
                stagger: 0.05,
                onComplete: function() {
                    // Show next set
                    showNewsSet(nextIndex, false);
                    currentIndex = nextIndex;
                    isTransitioning = false;
                }
            });
            
            // Schedule next transition
            startAutoTransition();
        }
        
        function startAutoTransition() {
            if (autoplayTimer) {
                autoplayTimer.kill();
            }
            
            if (isPaused) return;
            
            autoplayTimer = gsap.delayedCall(cycleDuration, transitionToNextSet);
        }
        
        function stopAutoTransition() {
            isPaused = true;
            if (autoplayTimer) {
                autoplayTimer.kill();
                autoplayTimer = null;
            }
        }
        
        function resumeAutoTransition() {
            isPaused = false;
            if (!isTransitioning) {
                startAutoTransition();
            }
        }
        
        // Pause on hover
        $slider.hover(
            function() { stopAutoTransition(); },
            function() { resumeAutoTransition(); }
        );
        
        // Initialize slider
        initSlider();
        
        // Handle window resize
        $(window).on('resize', function() {
            var newCardsPerSlide = getCardsPerSlide();
            var newShouldActivate = shouldActivateSlider();
            
            // Kill current timer
            if (autoplayTimer) {
                autoplayTimer.kill();
                autoplayTimer = null;
            }
            
            if (!newShouldActivate) {
                // Show all news items without slider
                $container.empty();
                $newsItems.appendTo($container);
            } else {
                // Reinitialize slider with new settings
                currentIndex = 0;
                isTransitioning = false;
                isPaused = false;
                initSlider();
            }
        });
    });
});

///////////////////////////////////////
// CTA TYPE 1 - ILLUSTRATION ANIMATION

$(document).ready(function() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    $('section[data-section="ctaType1"]').each(function() {
        var $section = $(this);
        var $illustration = $section.find('.illustration-holder');

        if (!$illustration.length) return;

        gsap.set($illustration, {
            opacity: 0,
            x: 80
        });

        gsap.to($illustration, {
            opacity: 1,
            x: 0,
            duration: 0.9,
            ease: "back.out(1.4)",
            scrollTrigger: {
                trigger: $illustration[0],
                start: "top 85%",
                toggleActions: "play none none none",
                once: true
            }
        });
    });
});


///////////////////////////////////////
// CARDS TYPE 1 - SCROLL PINNED CARD ANIMATIONS
///////////////////////////////////////
// SLIDER TYPE 1 - ILLUSTRATION ANIMATION

$(document).ready(function() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    $('section[data-section="sliderType1"]').each(function() {
        var $section = $(this);
        var $illustration = $section.find('.illustrationHolder, .illustration-holder');

        if (!$illustration.length) return;

        gsap.set($illustration, {
            opacity: 0,
            x: 120
        });

        gsap.to($illustration, {
            opacity: 1,
            x: 0,
            duration: 0.8,
            ease: "back.out(1.4)",
            scrollTrigger: {
                trigger: $illustration[0],
                start: "top 90%",
                invalidateOnRefresh: true,
                toggleActions: "play none none none",
                once: true
            }
        });
    });
});

///////////////////////////////////////
// CARDS TYPE 1 - SCROLL PINNED CARD ANIMATIONS

$(document).ready(function() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    $('section[data-section="textType4"]').each(function() {
        var $section = $(this);
        var $illustration = $section.find('.illustration-holder');

        if (!$illustration.length) return;

        gsap.set($illustration, {
            opacity: 0,
            x: 120
        });

        gsap.to($illustration, {
            opacity: 1,
            x: 0,
            duration: 0.9,
            ease: "back.out(1.4)",
            scrollTrigger: {
                trigger: $illustration[0],
                start: "top 90%",
                invalidateOnRefresh: true,
                toggleActions: "play none none none",
                once: true
            }
        });
    });

    $('section[data-section="formType1"]').each(function() {
        var $section = $(this);
        var $illustration = $section.find('.illustration-holder');

        if (!$illustration.length) return;

        gsap.set($illustration, {
            opacity: 0,
            scale: 0.6,
            transformOrigin: "center center"
        });

        gsap.to($illustration, {
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "back.out(1.6)",
            scrollTrigger: {
                trigger: $illustration[0],
                start: "top 90%",
                invalidateOnRefresh: true,
                toggleActions: "play none none none",
                once: true
            }
        });
    });

    $('section[data-section="cardsType1"]').each(function() {
        var $section = $(this);
        var $cards = $section.find('.block.team');
        var $intro = $section.find('.row-intro');
        var $illustration = $section.find('.illustration-holder');
        
        if (!$cards.length) return;
        
        // Check if we're on mobile - disable animation below 1024px
        function isMobile() {
            return window.innerWidth < 1024;
        }
        
        // If mobile, just show cards normally without animation
        if (isMobile()) {
            gsap.set($cards, {
                y: 0,
                opacity: 1
            });
            if ($illustration.length) {
                gsap.set($illustration, {
                    opacity: 1,
                    x: 0,
                    y: 0
                });
            }
            return; // Exit early, no animation setup
        }
        
        // Set initial state - cards hidden below viewport (desktop only)
        gsap.set($cards, {
            y: "100vh", // Start cards below the viewport
            opacity: 0
        });

        if ($illustration.length) {
            gsap.set($illustration, {
                opacity: 0,
                x: -120,
                y: 120
            });
        }
        
        // Create the scroll-triggered animation sequence
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: $section[0],
                start: "top top", // Start pinning slightly before section hits top - smoother entry
                end: "+=800vh", // Pin for 800vh (8 viewport heights) - very long and smooth
                pin: true, // Pin the section
                pinSpacing: true, // Prevents layout shift and magnetic feeling
                scrub: 3, // Even slower, ultra-smooth scrubbing
                anticipatePin: 1, // Prevent jank when pinning
                invalidateOnRefresh: true, // Recalculate on resize for responsive behavior
                onUpdate: function(self) {
                    // Optional: Add progress-based effects here
                    // console.log("Progress:", self.progress);
                }
            }
        });
        
        var cardAnimationDuration = 1;
        var illustrationAdded = false;

        // Add each card animation to the timeline
        $cards.each(function(index) {
            var $card = $(this);
            
            // Calculate stagger timing - each card starts 20% through the scroll
            var startProgress = index * 0.2; // 0%, 20%, 40% etc.
            var endProgress = startProgress + 0.25; // Each animation takes 25% of scroll
            
            // Add to timeline with precise timing
            tl.to($card, {
                y: 0, // Move to final position
                opacity: 1,
                duration: cardAnimationDuration, // Duration in timeline units
                ease: "power4.out", // Ultra-smooth easing
                immediateRender: false
            }, startProgress); // Start at calculated progress point

            if (!illustrationAdded) {
                var startOffset = startProgress + (cardAnimationDuration * 0.3);
                addCtaType2IllustrationAnimation(tl, $section, startOffset);
                illustrationAdded = true;
            }
        });

        if (!illustrationAdded) {
            addCtaType2IllustrationAnimation(tl, $section, 0);
        }

        if ($illustration.length) {
            tl.to($illustration, {
                opacity: 1,
                x: 0,
                y: 0,
                duration: 1,
                ease: "back.out(1.4)",
                immediateRender: false
            }, "+=0.2");
        }
        
        // Optional: Add intro text animation at the beginning
        if ($intro.length) {
            gsap.fromTo($intro, {
                opacity: 0,
                y: 30
            }, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: $section[0],
                    start: "top 80%",
                    end: "top 60%",
                    toggleActions: "play none none reverse",
                    invalidateOnRefresh: true // Recalculate on resize for responsive behavior
                }
            });
        }
        
        // Handle window resize - refresh page to reinitialize animation
        $(window).on('resize', debounce(function() {
            window.location.reload();
        }, 250));
    });
});

function addCtaType2IllustrationAnimation(timeline, $section, startPosition) {
    var $illustration = $section.find('.illustration-holder');
    if (!$illustration.length) return;

    gsap.set($illustration, {
        opacity: 0,
        x: -120,
        y: 120
    });

    timeline.to($illustration, {
        opacity: 1,
        x: 0,
        y: 0,
        duration: 0.9,
        ease: "back.out(1.4)",
        immediateRender: false
    }, startPosition);
}

///////////////////////////////////////
// CTA TYPE 2 - SCROLL PINNED CARD ANIMATIONS

$(document).ready(function() {
    $('section[data-section="ctaType2"]').each(function() {
        var $section = $(this);
        var $cards = $section.find('.card-service');
        var $intro = $section.find('.row-intro');
        
        if (!$cards.length) return;
        
        // Check if we're on mobile - disable animation below 1024px
        function isMobile() {
            return window.innerWidth < 1024;
        }
        
        // If mobile, just show cards normally without animation
        if (isMobile()) {
            gsap.set($cards, {
                y: 0,
                opacity: 1
            });
            return; // Exit early, no animation setup
        }
        
        // Set initial state - cards hidden below viewport (desktop only)
        gsap.set($cards, {
            y: "100vh", // Start cards below the viewport
            opacity: 0
        });
        
        // Create the scroll-triggered animation sequence
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: $section[0],
                start: "top top", // Start pinning slightly before section hits top - smoother entry
                end: "+=800vh", // Pin for 600vh (6 viewport heights) - very long and smooth
                pin: true, // Pin the section
                pinSpacing: true, // Prevents layout shift and magnetic feeling
                scrub: 3, // Even slower, ultra-smooth scrubbing
                anticipatePin: 1, // Prevent jank when pinning
                onUpdate: function(self) {
                    // Optional: Add progress-based effects here
                    // console.log("Progress:", self.progress);
                }
            }
        });
        
        // Add each card animation to the timeline
        $cards.each(function(index) {
            var $card = $(this);
            
            // Calculate stagger timing - each card starts 20% through the scroll
            var startProgress = index * 0.2; // 0%, 20%, 40% etc.
            var endProgress = startProgress + 0.25; // Each animation takes 25% of scroll
            
            // Add to timeline with precise timing
            tl.to($card, {
                y: 0, // Move to final position
                opacity: 1,
                duration: 1, // Duration in timeline units
                ease: "power4.out", // Ultra-smooth easing
                immediateRender: false
            }, startProgress); // Start at calculated progress point
        });
        
        // Optional: Add intro text animation at the beginning
        if ($intro.length) {
            gsap.fromTo($intro, {
                opacity: 0,
                y: 30
            }, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: $section[0],
                    start: "top 80%",
                    end: "top 60%",
                    toggleActions: "play none none reverse",
                    invalidateOnRefresh: true // Recalculate on resize for responsive behavior
                }
            });
        }
        
        // Handle window resize - destroy/recreate animation if needed
        var currentAnimation = tl;
        $(window).on('resize', function() {
            if (isMobile()) {
                // If switched to mobile, kill animation and show cards
                if (currentAnimation) {
                    currentAnimation.kill();
                    ScrollTrigger.getAll().forEach(trigger => {
                        if (trigger.trigger === $section[0]) {
                            trigger.kill();
                        }
                    });
                }
                gsap.set($cards, { y: 0, opacity: 1 });
            } else {
                // If switched to desktop, refresh ScrollTrigger
                ScrollTrigger.refresh();
                console.log('ScrollTrigger refreshed');
            }
        });
    });
});

///////////////////////////////////////
// BADGE POP-IN ANIMATION

$(document).ready(function() {
    // Initialize badges with hidden state
    $('[data-badge]').each(function() {
        var $badge = $(this);
        
        // Set initial hidden state
        gsap.set($badge, {
            opacity: 0,
            scale: 0.3,
            rotation: -10
        });
    });
    
    // Create scroll-triggered animations
    $('[data-badge]').each(function() {
        var $badge = $(this);
        var badgeElement = this;
        
        // Create scroll trigger for this badge
        gsap.to(badgeElement, {
            opacity: 1,
            scale: 1,
            rotation: 0,
            duration: 0.6,
            ease: "back.out(1.4)", // Subtle bounce
            scrollTrigger: {
                trigger: badgeElement,
                start: "top 85%", // Start animation when badge is 85% down the viewport
                end: "bottom 15%",
                toggleActions: "play none none reverse",
                once: false // Allow reverse animation when scrolling back up
            }
        });
    });
});


///////////////////////////////////////
// FOOTER SVG PATH DRAWING ANIMATION

$(document).ready(function() {
    $('[data-footer-logo-animation]').each(function() {
        var $container = $(this);
        var $svg = $container.find('svg');
        var $paths = $svg.find('path');
        
        if ($paths.length < 2) return; // Need at least 2 paths (text and curve)
        
        // The smile curve is typically the second path
        var $smilePath = $paths.eq(1); // Second path (index 1)
        var $textPath = $paths.eq(0);  // First path (text)
        
        // Set up initial states for smile and text
        gsap.set($smilePath, { 
            opacity: 0, 
            scale: 0.3,
            transformOrigin: "center center"
        });
        gsap.set($textPath, { opacity: 0, y: 20 });
        
        // Create scroll trigger animation
        var tl = gsap.timeline({
            scrollTrigger: {
                trigger: $container[0],
                start: "top 80%",
                end: "bottom 20%",
                toggleActions: "play none none reverse"
            }
        });
        
        // Animate the smile with a gentle bounce
        tl.to($smilePath, {
            opacity: 1,
            scale: 1,
            duration: 0.8,
            ease: "back.out(1.2)" // Gentle bounce
        })
        // Then pop in the text with bounce
        .to($textPath, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "back.out(1.4)"
        }, "-=0.2"); // Start text animation 0.2 seconds before smile completes
    });
});



// CUSTOM FILE UPLOAD
$(document).ready(function() {
    let uploadedFiles = [];
    let isProcessingFiles = false; // Prevent concurrent processing
    const maxFiles = 5;
    const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const maxFileSize = 10 * 1024 * 1024; // 10MB

    // Hide the original file input and placeholder
    const $nativeInput = $('#form-input-attachments');
    $nativeInput.hide();
    $('[data-placeholder]').hide();

    // Ensure files grid exists and is placed OUTSIDE the Freeform label
    const $label = $nativeInput.closest('label.freeform-label');
    let $grid = $('#filesGrid');
    if (!$grid.length) {
        $grid = $('<div class="files-grid" id="filesGrid"><div class="add-file-box" id="addFileBox"></div></div>');
    } else {
        // Detach in case it's currently inside the label
        $grid = $grid.detach();
    }
    if ($label.length) {
        $label.after($grid);
    }

    // Click handler for add file box
    $(document).on('click', '#addFileBox', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('Custom upload triggered');
        $('#form-input-attachments').trigger('click');
    });

    // Prevent the original placeholder from triggering
    $(document).on('click', '[data-placeholder]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    });

    // Prevent file preview clicks from triggering upload
    $(document).on('click', '.file-preview', function(e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
    });

    // Helper function to check if file already exists (by name and size)
    function fileExists(file) {
        return uploadedFiles.some(f => 
            f.file.name === file.name && 
            f.file.size === file.size &&
            f.file.lastModified === file.lastModified
        );
    }

    // File input change handler
    $('#form-input-attachments').on('change', function(e) {
        // Prevent concurrent processing
        if (isProcessingFiles) {
            console.log('[File Input] Already processing files, skipping...');
            return;
        }
        
        isProcessingFiles = true;
        console.log('File input changed');
        const input = e.target;
        const selectedFiles = Array.from(input.files);
        
        console.log('[File Input] Selected files:', selectedFiles.map(f => f.name));
        console.log('[File Input] Current uploadedFiles:', uploadedFiles.map(f => f.file.name));
        
        let newFilesAdded = false;
        const filesToAdd = [];
        
        // First, filter out any files that already exist in our array
        selectedFiles.forEach(file => {
            // Check for duplicates - must match name, size, AND lastModified time
            if (fileExists(file)) {
                console.log('[File Input] Skipping duplicate:', file.name, 'Size:', file.size, 'Modified:', file.lastModified);
                return; // Skip this file
            }

            // Validate file type
            if (!allowedTypes.includes(file.type)) {
                alert(`File ${file.name} is not allowed. Only PDF and JPG files are accepted.`);
                return;
            }

            // Validate file size
            if (file.size > maxFileSize) {
                alert(`File ${file.name} is too large. Maximum size is 10MB.`);
                return;
            }

            // Check max files limit
            if (uploadedFiles.length >= maxFiles) {
                alert(`Maximum ${maxFiles} files allowed.`);
                return;
            }

            // This is a new file - add to queue
            filesToAdd.push(file);
        });

        // Add all new files to our array
        filesToAdd.forEach(file => {
            const fileObj = {
                file: file,
                id: Date.now() + Math.random()
            };
            uploadedFiles.push(fileObj);
            newFilesAdded = true;

            // Create preview
            createFilePreview(fileObj);
        });

        // Clear the input value immediately to prevent re-processing
        $(this).val('');
        
        // Update UI
        updateUI();
        
        // Sync native input immediately if files were added (without triggering change event)
        // This updates the input without causing Freeform to process files immediately
        if (newFilesAdded) {
            console.log('[File Input] Added', filesToAdd.length, 'new file(s). Total files:', uploadedFiles.length);
            syncNativeInputFiles(false);
        } else {
            console.log('[File Input] No new files added');
        }
        
        // Reset processing flag
        isProcessingFiles = false;
    });

    function createFilePreview(fileObj) {
        let previewContent = '';
        
        if (fileObj.file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = function(e) {
                previewContent = `<img src="${e.target.result}" alt="${fileObj.file.name}">`;
                renderPreview(fileObj, previewContent);
            };
            reader.readAsDataURL(fileObj.file);
        } else {
            // For PDF, show a placeholder
            previewContent = `
                <div style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; background: #f3f4f6;">
                    <div style="text-align: center;">
                        <div style="font-size: 48px; color: #9ca3af; margin-bottom: 10px;">📄</div>
                        <div style="color: #6b7280; font-size: 14px;">PDF</div>
                    </div>
                </div>
            `;
            renderPreview(fileObj, previewContent);
        }
    }

    function renderPreview(fileObj, previewContent) {
        const preview = $(`
            <div class="file-preview" data-file-id="${fileObj.id}">
                ${previewContent}
                <div class="file-info">${fileObj.file.name}</div>
                <div class="remove-file"></div>
            </div>
        `);

        // Insert before the add button
        preview.insertBefore('#addFileBox');

        // Animate entrance
        preview.css({ opacity: 0, transform: 'scale(0.8)' });
        setTimeout(() => {
            preview.css({ 
                opacity: 1, 
                transform: 'scale(1)',
                transition: 'all 0.3s'
            });
        }, 10);
    }

    // Remove file handler
    $(document).on('click', '.remove-file', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        const preview = $(this).closest('.file-preview');
        const fileId = preview.data('file-id');
        
        console.log('Removing file:', fileId);
        
        // Remove from array immediately (before animation)
        uploadedFiles = uploadedFiles.filter(f => f.id !== fileId);
        
        // Sync native input immediately to ensure form data is updated (without triggering change)
        // This prevents Freeform from processing during removal
        syncNativeInputFiles(false);
        
        // Animate removal
        preview.css({ 
            opacity: 0, 
            transform: 'scale(0.8)',
            transition: 'all 0.3s'
        });
        
        setTimeout(() => {
            preview.remove();
            updateUI();
        }, 300);
        
        return false;
    });

    function updateUI() {
        // Hide/show add button based on file count
        if (uploadedFiles.length >= maxFiles) {
            $('#addFileBox').hide();
        } else {
            $('#addFileBox').show();
        }
    }

    // Synchronize our uploadedFiles array into the native Freeform input
    function syncNativeInputFiles(triggerChange = false) {
        const $form = $('#filesGrid').closest('form');
        const originalInput = $form.find('#form-input-attachments')[0];
        if (!originalInput) return;
        
        // First, clean up uploadedFiles array to remove any duplicates
        const seen = new Map();
        const cleanedFiles = [];
        uploadedFiles.forEach(fileObj => {
            const file = fileObj.file;
            const key = `${file.name}_${file.size}_${file.lastModified}`;
            if (!seen.has(key)) {
                seen.set(key, true);
                cleanedFiles.push(fileObj);
            } else {
                console.warn('[Sync] Removing duplicate from uploadedFiles:', file.name);
            }
        });
        uploadedFiles = cleanedFiles;
        
        // Create new DataTransfer object - this ensures we start fresh
        const dt = new DataTransfer();
        
        // Add all unique files from our cleaned array
        uploadedFiles.forEach(fileObj => {
            dt.items.add(fileObj.file);
        });
        
        // Set files on input - this should replace any existing files
        try {
            originalInput.files = dt.files;
        } catch (e) {
            console.error('[Sync] Error setting files:', e);
            // Fallback: try replacing the input element
            const $input = $(originalInput);
            const $newInput = $input.clone();
            $newInput[0].files = dt.files;
            $input.replaceWith($newInput);
        }
        
        // Only trigger change event if explicitly requested (e.g., on submit)
        // This prevents Freeform from processing files immediately on add/remove
        if (triggerChange) {
            // Use requestAnimationFrame to ensure files are set first
            requestAnimationFrame(() => {
                $('#form-input-attachments').trigger('change');
            });
        }
        
        console.group('[Custom Uploader] Synced files to native input');
        console.log('uploadedFiles array length:', uploadedFiles.length);
        const syncedInput = $('#form-input-attachments')[0];
        console.log('Synced files count:', syncedInput ? syncedInput.files.length : 0);
        if (syncedInput) {
            Array.from(syncedInput.files).forEach((f, i) => {
                console.log(`#${i + 1}:`, f.name, `${(f.size/1024).toFixed(1)}KB`, f.type, `Modified: ${f.lastModified}`);
            });
        }
        console.groupEnd();
        
        // Final safety check
        if (syncedInput && uploadedFiles.length !== syncedInput.files.length) {
            console.error('[Sync] CRITICAL: Mismatch after sync! uploadedFiles:', uploadedFiles.length, 'Input files:', syncedInput.files.length);
        }
    }


    // Submit handler - ensure Freeform receives the files
    $(document).on('submit', 'form', function(e) {
        const $form = $(this);
        if ($form.find('#filesGrid').length > 0) {
            console.group('[Custom Uploader] Form submission started');
            console.log('uploadedFiles before sync:', uploadedFiles.map(f => f.file.name));
            
            // Clean and sync files immediately before submission (synchronously)
            syncNativeInputFiles(true); // Trigger change so Freeform picks it up
            
            const input = $form.find('#form-input-attachments')[0];
            console.log('[Custom Uploader] Input files after sync:', input ? input.files.length : 0);
            
            if (input) {
                Array.from(input.files).forEach((f, i) => {
                    console.log(`Input file #${i + 1}:`, f.name, `${(f.size/1024).toFixed(1)}KB`);
                });
            }
            
            // Verify files are synced correctly
            if (input && input.files.length !== uploadedFiles.length) {
                console.error('[Custom Uploader] CRITICAL: File count mismatch! Expected:', uploadedFiles.length, 'Got:', input.files.length);
                // Force one more sync
                syncNativeInputFiles(true);
            }
            
            // Double-check the input has files before allowing submission
            if (input && input.files.length === 0 && uploadedFiles.length > 0) {
                console.error('[Custom Uploader] WARNING: Input has no files but uploadedFiles has', uploadedFiles.length);
                // Try one more time with a fresh DataTransfer
                const dt = new DataTransfer();
                uploadedFiles.forEach(fileObj => dt.items.add(fileObj.file));
                input.files = dt.files;
                console.log('[Custom Uploader] Manually set files, new count:', input.files.length);
            }
            
            console.log('[Custom Uploader] Final file count:', uploadedFiles.length);
            console.groupEnd();
        }
    });
});

// REMOVE FOOTER SPACING IF NO FORM
if ($('[data-section="formType1"]').length <= 0) {
    $('footer').css('padding-top', '72px');
}